import {TableColumnData} from "../../../../types/common";
import React, {useMemo} from "react";
import {OrganShareDTO} from "../../../../types/organShare";

export function useOrganShareColumns() {

    const organNameColumn: TableColumnData<OrganShareDTO> = useMemo(
        () => ({
            accessor: "organName",
            header: "소속 이름",
            sortable: false,
            getNode: (vo: OrganShareDTO) => <span>{vo.organName}</span>,
        }), []);

    const managerNameColumn: TableColumnData<OrganShareDTO> = useMemo(
        () => ({
            accessor: "organManagerName",
            header: "소속 관리자",
            sortable: false,
            getNode: (vo: OrganShareDTO) => <span>{vo.organManagerName}</span>,
        }), []);

    const managerEmailColumn: TableColumnData<OrganShareDTO> = useMemo(
        () => ({
            accessor: "organManagerEmail",
            header: "소속 관리자 아이디",
            sortable: false,
            getNode: (vo: OrganShareDTO) => <span>{vo.organManagerEmail}</span>,
        }), []);

    const managerPhoneNumberColumn: TableColumnData<OrganShareDTO> = useMemo(
        () => ({
            accessor: "organManagerPhoneNumber",
            header: "소속 관리자 전화번호",
            sortable: false,
            getNode: (vo: OrganShareDTO) => <span>{`(${vo.organManagerCodePhone}) ${vo.organManagerPhoneNumber}`}</span>,
        }), []);

    const columns: TableColumnData<OrganShareDTO>[] = useMemo(
        () => [
            organNameColumn,
            managerNameColumn,
            managerEmailColumn,
            managerPhoneNumberColumn,
        ],
        [
            organNameColumn,
            managerNameColumn,
            managerEmailColumn,
            managerPhoneNumberColumn,
        ]
    );


    return {
        columns,
    };
}